import { FC } from "react";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { CounterpartyForm } from "../../counterpartyForm";
import { useCreateCounterparty } from "../../dataHooks/counterpartyQueries";

type Props = {};

export const NewTC: FC<Props> = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const createCounterparty = useCreateCounterparty({
    onSuccess: () => navigate("/tradingcounterparties")
  });

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      onClose={() => navigate("/tradingcounterparties")}
      open={location.pathname === "/tradingcounterparties/new"}
    >
      <DialogTitle>
        <Typography variant="h5">Onboard New Trading Counterparty</Typography>
      </DialogTitle>
      <DialogContent>
        <CounterpartyForm
          onSubmit={(payload) => createCounterparty.mutate(payload)}
          submitting={createCounterparty.isPending}
          submitLabel="Create"
          onCancel={() => navigate("/tradingcounterparties")}
        />
      </DialogContent>
    </Dialog>
  );
};
